export default __webpack_public_path__ + "static/media/Messages.b3fd4187.jpg";